// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"1a145b9b","115":"a9e3e984","880":"f335d4b1"}[chunkId] + ".chunk.js";
};